var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.block},_vm._l((_vm.clientsByGroup),function(group,groupId){return _c('div',{key:`${groupId}-${_vm.count.groups}`,class:_vm.$style.group},_vm._l((group),function(client,clientId){return _c('div',{key:clientId,class:_vm.$style.item},[_c('img',{class:_vm.$style.logo,attrs:{"src":client.url,"alt":client.name}})])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }